import { CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryFormValues } from '../CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry/CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryForm';
import apiClient from '../../../../Services/ApiClient';
import { CSSZSickLeaveCertificate } from '../../Interfaces/CSSZ.interface';
import useApiClient from '../../../Base/Hooks/useApiClient';
import { CSSZSickLeaveCertificateReturnAdmissionRequestFormValues } from '../CSSZSickLeaveCertificateReturnAdmissionRequest/CSSZSickLeaveCertificateReturnAdmissionRequestForm';
import { CSSZSickLeaveCertificateRequestForChooseOutingsTimeFormValues } from '../CSSZSickLeaveCertificateRequestForChooseOutingsTime/CSSZSickLeaveCertificateRequestForChooseOutingsTimeForm';
import { CSSZSickLeaveCertificateConfirmationOfDurationRequestBody } from '../CSSZSickLeaveCertificateConfirmationOfDuration/CSSZSickLeaveCertificateConfirmationOfDurationForm';
import { CSSZSickLeaveCertificateEndOfSickLeaveValues } from '../CSSZSickLeaveCertificateEndOfSickLeave/CSSZSickLeaveCertificateEndOfSickLeave';
import { CSSZSickLeaveCertificateAttendingDoctorReportValues } from '../CSSZSickLeaveCertificateAttendingDoctorReport/CSSZSickLeaveCertificateAttendingDoctorReport';
import useLoading from '../../../Base/Hooks/useLoading';
import useNotification from '../../../../Hooks/useNotification.hook';

export default function useCSSZSickLeaveForm({
	patientId,
	sickLeaveCertificate,
	endpoint,
}: {
	patientId: string;
	sickLeaveCertificate: CSSZSickLeaveCertificate;
	endpoint: string;
}) {
	const { displayError, showUnexpectedError } = useApiClient();
	const { isLoading, setIsLoading } = useLoading(false);
	const { showNotificationSuccess } = useNotification();

	type AllowedValues =
		| CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryFormValues
		| CSSZSickLeaveCertificateReturnAdmissionRequestFormValues
		| CSSZSickLeaveCertificateRequestForChooseOutingsTimeFormValues
		| CSSZSickLeaveCertificateConfirmationOfDurationRequestBody
		| CSSZSickLeaveCertificateAttendingDoctorReportValues
		| CSSZSickLeaveCertificateEndOfSickLeaveValues;

	type WithOptionalFile<T> = T & { file?: File | null };

	const post = async (
		values: WithOptionalFile<AllowedValues>,
		onCreate: (jobId?: string) => void,
	) => {
		setIsLoading(true);
		const { file, ...payload } = values;
		try {
			const response = await apiClient.post(
				`/user/${patientId}/sick-leave/${sickLeaveCertificate.id}/${endpoint}`,
				payload,
			);

			let jobId: string | undefined;

			if (file && response.data?.id) {
				const formData = new FormData();
				formData.append('files[]', file);

				const res = await apiClient.postMultipart(
					`/user/${patientId}/sick-leave/${sickLeaveCertificate.id}/${endpoint}/${response.data.id}/upload`,
					formData,
				);

				if (res.status === 200 || res.status === 202) {
					jobId = res.data?.jobId;
				} else {
					showUnexpectedError();
					return;
				}
			}

			if (response.status === 200) {
				showNotificationSuccess({
					content:
						'component.CSSZSickLeaveCertificateDetailControls.actionSuccessDefaultMessage',
				});
				onCreate(jobId);
			} else {
				showUnexpectedError();
			}
		} catch (e) {
			displayError(e);
		} finally {
			setIsLoading(false);
		}
	};

	return {
		post,
		isLoading,
	};
}
